<template>
  <v-app class="c-splash-screen" data-testid="app-splash-screen">
    <div class="c-splash-screen__content">
      <v-progress-circular indeterminate color="primary" size="48" />
    </div>
  </v-app>
</template>

<style scoped>
.c-splash-screen__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #fff;
}
</style>
